// Caminhos antigos dos links de avisos/push (até 27/09 o servidor gravava rotas que não existem no web). Avisos
// antigos continuam no banco e em notificações nos celulares: cada caminho aqui só redireciona (replace) para a
// rota atual, preservando o id e a query. Links novos saem de server/src/modulos/notificacoes/links.ts; o teste
// rotas.links-avisos.test.ts confere os dois lados. Não apagar: aviso não expira.
import { Navigate, useLocation, useParams, type Params, type RouteObject } from "react-router";

export interface CaminhoLegado {
  /** Padrão antigo (absoluto). */
  de: string;
  /** Destino atual a partir dos params e da query do link antigo. */
  para: (params: Params, busca: URLSearchParams) => string;
}

const comBusca = (caminho: string, busca: URLSearchParams) => (busca.size ? `${caminho}?${busca}` : caminho);
const id = (params: Params) => encodeURIComponent(params.id ?? "");

export const LEGADO_ALUNO: readonly CaminhoLegado[] = [
  { de: "/comunidade/posts/:id", para: (p, b) => comBusca(`/comunidade/post/${id(p)}`, b) },
  { de: "/eventos/:id", para: (p, b) => comBusca(`/comunidade/eventos/${id(p)}`, b) },
  { de: "/extrato", para: (_, b) => comBusca("/perfil/extrato", b) },
  { de: "/medalhas", para: (_, b) => comBusca("/perfil/medalhas", b) },
  { de: "/indicacoes", para: (_, b) => comBusca("/perfil/indicacoes", b) },
  { de: "/convites", para: (_, b) => comBusca("/perfil/convites", b) },
  { de: "/ganhe-pontos", para: (_, b) => comBusca("/perfil/pontos-extras", b) },
  // Era "/feedback?aba=MEUS"; a tela de feedback não lê query (abre em "Mais votados").
  { de: "/feedback", para: () => "/perfil/feedback" },
  // Prêmios a retirar aparecem no topo do Perfil.
];

/** Só no build web (rotas.painel.tsx): no app nativo todo /painel* já cai em PainelNoNavegador. */
export const LEGADO_PAINEL: readonly CaminhoLegado[] = [
  { de: "/painel/acoes/declaracoes", para: () => "/painel/pontos-extras" },
  {
    de: "/painel/comunidade/moderacao",
    para: (_, b) => `/painel/timeline?aba=${b.get("fila") === "DENUNCIAS" ? "denuncias" : "revisar"}`,
  },
];

function Redirecionar({ para }: Pick<CaminhoLegado, "para">) {
  const params = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={para(params, new URLSearchParams(search)) + hash} replace />;
}

export const rotasLegado = (caminhos: readonly CaminhoLegado[]): RouteObject[] =>
  caminhos.map(({ de, para }) => ({ path: de, element: <Redirecionar para={para} /> }));
